import { render, staticRenderFns } from "./h-banking-transactions-page.vue?vue&type=template&id=b25e7304&"
import script from "./h-banking-transactions-page.vue?vue&type=script&lang=js&"
export * from "./h-banking-transactions-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports